import { render } from "./foretag.vue?vue&type=template&id=e848a4d4"
import script from "./foretag.vue?vue&type=script&lang=js"
export * from "./foretag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__